<script>
import { authApi } from 'api'

export default {
  render (h) {
    return h()
  },
  beforeCreate () {
    if (!this.$route.query.token) {
      authApi.ssoLoginUrl(this.$route.query.bookId, this.$route.query.redirect).then(redirect => { window.location = redirect })
      return
    }

    this.$store.dispatch('setToken', this.$route.query.token)
    this.$router.replace(this.$route.query.redirect !== undefined ? this.$route.query.redirect : '/book/' + this.$route.query.bookId)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue